var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pensionskassen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mutationen-abkl\\xE4ren",
    transform: "translate(-248.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drop-Down",
    transform: "translate(233.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail_outline-24px",
    transform: "translate(15.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 22 0 22 22 0 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333333,3.66666667 L3.66666667,3.66666667 C2.65833333,3.66666667 1.8425,4.49166667 1.8425,5.5 L1.83333333,16.5 C1.83333333,17.5083333 2.65833333,18.3333333 3.66666667,18.3333333 L18.3333333,18.3333333 C19.3416667,18.3333333 20.1666667,17.5083333 20.1666667,16.5 L20.1666667,5.5 C20.1666667,4.49166667 19.3416667,3.66666667 18.3333333,3.66666667 Z M18.3333333,16.5 L3.66666667,16.5 L3.66666667,7.33333333 L11,11.9166667 L18.3333333,7.33333333 L18.3333333,16.5 Z M11,10.0833333 L3.66666667,5.5 L18.3333333,5.5 L11,10.0833333 Z",
    id: "Shape",
    fill: "#242F38",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/Icon_Mail.da19076dea334d0b01773066bb311eb7.svg";
export { ForwardRef as ReactComponent };